<ion-card>
  <ion-header>
    <ion-toolbar>
      <ion-title *ngIf="mode === 'view'">{{ message.title }}</ion-title>
      <ion-title *ngIf="mode === 'edit'">
        <ion-item class="title"><ion-input [(ngModel)]="messageForEditing.title"></ion-input></ion-item>
      </ion-title>

      <ion-buttons slot="end">
        <ion-button *ngIf="canEdit && this.mode === 'view'" (click)="edit()">
          <ion-icon name="pencil"></ion-icon>
        </ion-button>
        <ion-button *ngIf="canEdit && this.mode === 'edit'" (click)="save()">
          <ion-icon name="checkmark"></ion-icon>
        </ion-button>
        <ion-button (click)="close()"><ion-icon name="close"></ion-icon></ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>

  <ion-card-header>
    <ion-card-subtitle>Od: {{ message.publishedByUser.fullName() }}</ion-card-subtitle>
  </ion-card-header>

  <ion-card-content class="message-content">
    <ng-container *ngIf="mode === 'view'">
      <div [innerHTML]="message.content | bypassHtmlSanitizer"></div>
      <div *ngIf="message.attachmentUri" class="attachments">
        <div>Příloha</div>
        <ul>
          <li (click)="viewAttachment()">
            <a>{{ FileUploadService.parseFileNameFromUrl(message.attachmentUri) }} ({{ size | fileSize }})</a>
          </li>
        </ul>
      </div>
    </ng-container>

    <ng-container *ngIf="mode === 'edit'">
      <ejs-richtexteditor
        [toolbarSettings]="tools"
        [insertImageSettings]="rteInsertImageSettings"
        [(ngModel)]="messageForEditing.content"
      ></ejs-richtexteditor>

      <div class="attachments">
        <div>Příloha</div>
        <ion-item lines="none">
          <ng-container *ngIf="messageForEditing.attachmentUri">
            <ion-button slot="start" color="danger" fill="clear" (click)="removeAttachment()">
              <ion-icon name="close"></ion-icon>
            </ion-button>
            <ion-label>
              {{ FileUploadService.parseFileNameFromUrl(messageForEditing.attachmentUri) }} ({{ size | fileSize }})
            </ion-label>
          </ng-container>
          <ng-container *ngIf="!messageForEditing.attachmentUri">
            <ion-button slot="start" color="tertiary" shape="round" (click)="selectFile()">
              <ion-icon name="cloud-upload"></ion-icon>
            </ion-button>
            <ion-label>Přiložit soubor</ion-label>
            <input type="file" #fileInput style="display: none" (change)="onFileInput()" />
          </ng-container>
        </ion-item>
      </div>
    </ng-container>
  </ion-card-content>

  <ion-footer>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-button (click)="close()">Zpět</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>
</ion-card>
